export var TalkingPointCreateOption;
(function (TalkingPointCreateOption) {
    TalkingPointCreateOption["BLANK_TALKING_POINT"] = "blank_talking_point";
    TalkingPointCreateOption["NEW_FROM_TEMPLATE"] = "new_from_template";
})(TalkingPointCreateOption || (TalkingPointCreateOption = {}));
/**
 * Valid options for columns to sort by on the Talking Points list page.
 */
export var TalkingPointsListPageSortColumn;
(function (TalkingPointsListPageSortColumn) {
    TalkingPointsListPageSortColumn["NAME"] = "name";
    TalkingPointsListPageSortColumn["OWNER_NAME"] = "owner_name";
    TalkingPointsListPageSortColumn["USER_MODIFY_DATE"] = "user_modify_date";
    TalkingPointsListPageSortColumn["TEMPLATE_TYPE"] = "template_type";
})(TalkingPointsListPageSortColumn || (TalkingPointsListPageSortColumn = {}));
